import React, {useEffect} from "react";

export const AddNewOptionsButtonGroup = (props) => {
    const {state, setState, updateOptions, updateProperty, elementIdAutoIncrement} = props;
    const showAddNewClassName = `new ${state.showAddNew ? "active" : ""}`;

    const onClickAddNewButton = () => {
        setState(prevState => ({
            ...prevState,
            showAddNew: !prevState.showAddNew
        }));
    }

    useEffect(() => {
        updateOptions(state.func);
        updateProperty('elementIdAutoIncrement', elementIdAutoIncrement + 1)
    }, [state.func])

    const onClickNew = (isValue) => {
        console.log(state.func);
        let newCondition;
        if (isValue) {
            newCondition = {
                type: "constantValue",
                funcType: "none",
                value: "",
                defaultValue: "",
                id: elementIdAutoIncrement + 1
            };
        } else {
            newCondition = {
                funcName: "+",
                funcArgs: [],
                id: elementIdAutoIncrement + 1
            };
        }


        setState(prevState => {
            const newFuncArgs = Array.isArray(prevState.func.funcArgs)
                ? [...prevState.func.funcArgs, newCondition]
                : [newCondition];

            return {
                ...prevState,
                func: {
                    ...prevState.func,
                    funcArgs: newFuncArgs
                },
                showAddNew: false
            }
        });
    }


    return (
        <div className={"add-new-options"}>
            <button onClick={onClickAddNewButton} className={"add-new-button and"}>
                <span>+</span>
            </button>
            <div onClick={() => onClickNew(true)} className={showAddNewClassName}>
                New Value
            </div>
            <div onClick={() => onClickNew(false)} className={showAddNewClassName}>
                New Sub Query
            </div>
        </div>
    )
}